module.exports = __webpack_public_path__ + "img/camera.1cad020a.svg";